<div class="main-panel">
	<div style="color: #FFF; padding: 10px 15px; display: flex; align-items: center; justify-content: space-between;">
		<div style="font-size: 18px; font-weight: 700">Case Priorities</div>
		<div style="font-size: 22px;">
			<button mat-icon-button [routerLink]="[]">
				<span class="fal fa-close" style="font-size: 22px;"></span>
			</button>
		</div>
	</div>
	<hr style="border: 1px solid #E0E0E00A">
	<div style="display: flex; flex-direction: column; padding: 10px 15px;">
		<div *ngFor="let casePriority of casePriorities$ | async">
			<div style="display: flex; align-items: center; justify-content: flex-start; gap: 20px;">
				@if(casePriority.priority === 0) {
					<div style="color: red; display: flex; align-items: center; justify-content: center; flex-direction:  column; gap: 5px; font-size: 12px;">
						<div class="fa-solid fa-stop"></div>
						<div>Paused</div>
					</div>
				} @else {
					<div style="color: #45b549; display: flex; align-items: center; justify-content: center; flex-direction:  column; gap: 5px; font-size: 12px;">
						<div class="fa-solid fa-play"></div>
						<div>Active</div>
					</div>
				}
				<div>
					<div><strong>Case: {{ casePriority.caseName}}</strong></div>
					<div>Account: {{ casePriority?.accountName}}</div>
				</div>
				<div class="case-priority-meta" style="position: relative; display: flex; flex-grow: 1;flex-direction: column; justify-content: center;">
					<div style="flex-grow: 1; gap: 10px; display: flex; align-items: center; justify-content: center;">
						<span class="darker-font">{{ casePriority.priority }}</span>
						<mat-slider style="flex-grow:1" [min]="0" [max]="10" [step]="1">
							<input matSliderThumb (change)="setCasePriority(casePriority)" [(value)]="casePriority.priority"/>
						</mat-slider>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
